import { render, staticRenderFns } from "./DiseaseFullView.vue?vue&type=template&id=68a76dd2&scoped=true&"
import script from "./DiseaseFullView.vue?vue&type=script&lang=js&"
export * from "./DiseaseFullView.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseFullView.vue?vue&type=style&index=0&id=68a76dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a76dd2",
  null
  
)

export default component.exports